const UPLOAD_MAX_SIZE = 10

export { UPLOAD_MAX_SIZE }